import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ENV_CONFIG } from '@bn/shared/entities/injection-tokens';
import { AuthService } from '../services';

@Injectable()
export class AuthHeaderInterceptor implements HttpInterceptor {
  private readonly envConfig = inject(ENV_CONFIG);
  private readonly authService = inject(AuthService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const hasAccessKey =
      request.url.startsWith(this.envConfig.apiUrl) ||
      request.url.startsWith(this.envConfig.aiGatewayApiUrl) ||
      request.url.startsWith(this.envConfig.changelogSubscriptionApiUrl) ||
      request.url.startsWith(this.envConfig.apiMcUrl) ||
      request.url.startsWith(this.envConfig.apiEdgeDbLiteUrl) ||
      request.url.startsWith(this.envConfig.dnsLogsApiUrl) ||
      request.url.includes(this.envConfig.mcWsUrl) ||
      request.url.includes(this.envConfig.mcLoggingUrl) ||
      request.url.includes(this.envConfig.scriptingWsUrl) ||
      request.url.startsWith(this.envConfig.cdnLoggingReportApiUrl) ||
      request.url.startsWith(this.envConfig.cdnLogsApiUrl) ||
      request.url.startsWith(this.envConfig.computeScriptingTestApiUrl) ||
      request.url.startsWith(this.envConfig.shieldLogsUrl) ||
      request.url.startsWith(this.envConfig.cdnOriginErrorLogsUrl) ||
      request.url.startsWith(this.envConfig.surveysApiUrl);

    const PAT = this.authService.authStoreValue?.auth_token; // Personal Access Token (bunny)

    // NOTE: no PAT, no api need => does not belong here
    if (!PAT || !hasAccessKey) {
      return next.handle(request);
    }

    // add auth header token - PAT
    return next.handle(
      request.clone({
        headers: request.headers.set('Authorization', PAT),
      }),
    );
  }
}
